import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import swal from 'sweetalert2';

class EditShiftBlockInAdjust extends Component {
  constructor(props) {
    super(props);
    this.state={
      selectStartTime: moment(),
      selectEndTime: moment(),
      editId: 0,
      jobType: 6,
      eventObj: {},
      jobTypeList: [
        {
          id: 6,
          title: '正常班',
        },
        {
          id: 2,
          title: '可支援',
        },
        {
          id: 8,
          title: '例假',
        },
        {
          id: 9,
          title: '休假',
        },
        {
          id: 10,
          title: '國定假日排假',
        },
      ]
    }
    this.handleSelectStartTimeChange = this.handleSelectStartTimeChange.bind(this);
    this.handleSelectEndTimeChange = this.handleSelectEndTimeChange.bind(this);
    this.handleJobTypeChange = this.handleJobTypeChange.bind(this);
    this.handleSaveWorkTime = this.handleSaveWorkTime.bind(this);
    this.handledeleteWorkTime = this.handledeleteWorkTime.bind(this);

  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      eventObj: nextProps.event,
      editId: nextProps.event.id,
      selectStartTime: nextProps.event.start,
      selectEndTime: nextProps.event.end,
      jobType: nextProps.event.typerId
    })
  }

  handleSelectStartTimeChange(moment) {
    this.setState({
      selectStartTime: moment
    })
  }

  handleSelectEndTimeChange(moment) {
    this.setState({
      selectEndTime: moment
    })
  }

  handleJobTypeChange(e) {
    this.setState({
      jobType: e.target.value
    })
  }

  handleSaveWorkTime(e) {
    e.preventDefault();
    const { toggleOpen } = this.props;
    const { jobType, selectStartTime,  selectEndTime} = this.state;
    if (jobType === 0) {
      swal({
        type: 'error',
        text: '請選擇班別',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    }
    
    let data = {
      id: this.state.eventObj.id,
      start: selectStartTime.format('YYYY-MM-DD HH:mm'),
      end: selectEndTime.format('YYYY-MM-DD HH:mm'),
      actualStart: null,
      actualEnd: null,
      resourceId: jobType,
      title: ''
    }
    this.props.saveWorkTime(data);
    toggleOpen();
  }

  handledeleteWorkTime(e) {
    e.preventDefault();
    swal({
      type: 'warning',
      title: '確定刪除?',
      showCloseButton: true,
      heightAuto: false,
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#A9ABA8',
      confirmButtonText: '確定',
      cancelButtonText: '取消',
    }).then((result) => {
      if (result.value) {
        const { toggleOpen } = this.props;
        const { eventObj } = this.state;
        this.props.deleteWorkTime(eventObj);
        toggleOpen();
      }
    })
  }

  

  render() {
    let { isVisible, toggleOpen, event } = this.props;
    var isActivity = false;
    if (!isVisible) {
      return null;
    }else{
      isActivity = this.state.eventObj.title.indexOf('-') === -1
    }
    return (
      <div className="u-editblock fadeIn"  onClick={toggleOpen}>
        <div className="form-block" onClick={(e)=>{e.stopPropagation();}}>
          <div className="u-small-title">調整班別-{this.state.eventObj.title}</div>
          <form className="u-form">
            <div className="row">
              <div className="col-6 col-pad-12">
                <label className="u-form__label text-align-right">日期： {event.start.format('YYYY-MM-DD')}</label>
              </div>
                {
                  isActivity ? 
                  (
                  <div></div>
                  ):(
                  <div  className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right">班別：</label>
                      <select value={Number(this.state.jobType)} className="u-form__select" 
                        onChange={this.handleJobTypeChange}
                      >
                        <option value="0" disabled>請選擇</option>
                        {
                          this.state.jobTypeList.map(jobType => (
                            <option key={jobType.id} value={jobType.id}>{ jobType.title }</option>
                          ))
                        }
                      </select>
                    </div>
                  )
                }
            </div>
            <div className="row">
              <div className="col-6 col-pad-12">
                <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>時段：</label>
                <DatePicker
                  id="editStaff_selectStartTime"
                  locale="zh-tw"
                  showTimeSelect
                  showTimeSelectOnly
                  timeFormat="HH:mm"
                  dateFormat="LT"
                  timeCaption="Time"
                  selected={this.state.selectStartTime}
                  onChange={this.handleSelectStartTimeChange}
                  className="u-form__input mobile-hide"
                  disabledKeyboardNavigation
                />
                <button
                    className="btn datepickinput desktop--hide"
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('editStaff_selectStartTime').click();
                    }}
                >
                  {this.state.selectStartTime.format('HH:mm')}
                </button>
              </div>
              <div className="col-6 col-pad-12">
                <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>至：</label>
                <DatePicker
                  id="editStaff_selectEndTime"
                  locale="zh-tw"
                  showTimeSelect
                  showTimeSelectOnly
                  timeFormat="HH:mm"
                  dateFormat="LT"
                  timeCaption="Time"
                  selected={this.state.selectEndTime}
                  onChange={this.handleSelectEndTimeChange}
                  className="u-form__input mobile-hide"
                  disabledKeyboardNavigation
                />
                <button
                    className="btn datepickinput desktop--hide"
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('editStaff_selectEndTime').click();
                    }}
                >

                  { this.state.selectEndTime?(this.state.selectEndTime.format('HH:mm')):(<div></div>)}
                </button>
              </div> 
            </div>
            <div className="u-btn-group right">
              <button className="btn btn-md save" onClick={this.handleSaveWorkTime}>儲存</button>
              <button className="btn btn-md delete m-l-16" onClick={this.handledeleteWorkTime}>刪除</button>
              <button className="btn btn-md cancel m-l-16" onClick={
                (e) => {
                  e.preventDefault();
                  toggleOpen();
                }
              }>取消</button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default EditShiftBlockInAdjust;